<template>
    <div>
        <div class="row">
            <div :class="['col_12', {'loading_overlay': loading}]">
                <div class="card no_border">
                    <div class="card-header">
                        <div class="card-title">{{ title }}</div>
                    </div>
                    <div class="card-body pl_0 pr_0">
                        <div class="d_flex_end form_action_btn">
                            <router-link class="btn btn_blue ml_10" :to="{name: cancelRouteName}">{{ $t('common.back') }}</router-link>
                        </div>
                        
                        <div class="row">
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('subject_id')}]">
                                    <label>{{ $t('common.subject') }}</label>
                                    <select v-model="form.subject_id" class="form_global">
                                        <option value="">{{ $t('common.select_subject') }}</option>
                                        <option :value="subject.id" v-for="subject in subjects" :key="'subject_'+subject.id">{{ subject.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('subject_id')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('grade_id')}]">
                                    <label>{{ $t('common.grade') }}</label>
                                    <select v-model="form.grade_id" class="form_global" @change="changeData()">
                                        <option value="">{{ $t('common.select_grade') }}</option>
                                        <option :value="grade.id" v-for="grade in grades" :key="'grade '+grade.id">{{ grade.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('grade_id')" />
                                </div>
                            </div>

                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('semester_id')}]">
                                    <label>{{ $t('common.semester') }}</label>
                                    <select v-model="form.semester_id" class="form_global" @change="changeData()">
                                        <option value="">{{ $t('common.select_semester') }}</option>
                                        <option :value="semester.id" v-for="semester in semesters" :key="'semester '+semester.id">{{ semester.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('semester_id')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('unit_id')}]">
                                    <label>{{ $t('common.unit') }}</label>
                                    <select v-model="form.unit_id" class="form_global">
                                        <option value="">{{ $t('common.select_unit') }}</option>
                                        <option :value="unit.id" v-for="unit in units" :key="'unit '+unit.id">{{ unit.unit_name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('unit_id')" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('learning_goal')}]">
                                    <label>{{ $t('sidebar.lectureCommon.learning_goal') }}</label>
                                    <input type="text" class="form_global" v-model="form.learning_goal">
                                    <v-errors :errors="errorFor('learning_goal')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('lecture_areas')}]">
                                    <label>{{ $t('common.area') }}</label>
                                    <Multiselect
                                        v-model="areas"
                                        mode="tags"
                                        :placeholder="$t('common.select_area')"
                                        :close-on-select="false"
                                        :searchable="true"
                                        :create-option="true"
                                        :hideSelected="false"
                                        :options="areaList"
                                    />
                                    <v-errors :errors="errorFor('lecture_areas')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('parking_id')}]">
                                    <label>{{ $t('common.parking') }}</label>
                                    <select v-model="form.parking_id" class="form_global">
                                        <option value="">{{ $t('common.select_parking') }}</option>
                                        <option :value="parking.id" v-for="parking in parkings" :key="'parking '+parking.id">{{ parking.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('parking_id')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('chapter_id')}]">
                                    <label>{{ $t('common.chapter') }}</label>
                                    <select v-model="form.chapter_id" class="form_global">
                                        <option value="">{{ $t('common.select_chapter') }}</option>
                                        <option :value="chapter.id" v-for="chapter in chapters" :key="'parking '+chapter.id">{{ chapter.name }}</option>
                                    </select>
                                    <v-errors :errors="errorFor('chapter_id')" />
                                </div>
                            </div>
                            <!-- <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('page_number')}]">
                                    <label>{{ $t('sidebar.lectureCommon.page_number') }}</label>
                                    <input type="number" class="form_global" v-model="form.page_number" min="0">
                                    <v-errors :errors="errorFor('page_number')" />
                                </div>
                            </div> -->
                        </div>

                        <div class="row">
                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('video_name')}]">
                                    <label>{{ $t('common.name') }}</label>
                                    <input type="text" class="form_global" v-model="form.video_name">
                                    <v-errors :errors="errorFor('video_name')" />
                                </div>
                            </div>

                            <div class="col_3">
                                <div :class="['form-group', {'has_error': errorFor('status')}]">
                                    <label>{{ $t('common.status') }}</label>
                                    <div class="form_inline">
                                        <div class="form_radio">
                                            <input type="radio" id="active" value="1" v-model="form.status">
                                            <label for="active">{{ $t('common.active') }}</label>
                                        </div>
                                        <div class="form_radio">
                                            <input type="radio" id="inactive" value="0" v-model="form.status">
                                            <label for="inactive">{{ $t('common.inactive') }}</label>
                                        </div>
                                    </div>
                                    <v-errors :errors="errorFor('status')" />
                                </div>
                            </div>
                            <div class="col_3">
                                <div class="form-group ">
                                    <label>{{ $t('sidebar.lectureCommon.lecture_image') }}</label>
                                    <input type="file" class="form_global" ref="lecture_image" @input="onFileChange($event)" accept="image/png, image/gif, image/jpeg, image/webp">
                                    <v-errors :errors="errorFor('lecture_image')"></v-errors>
                                </div>
                            </div>
                            <div class="col_1">
                                <div class="thumbnail_img" v-if="tempLectureImage || form.lecture_image">
                                    <div class="inner">
                                        <img v-if="tempLectureImage" :src="tempLectureImage" alt="" >
                                        <img v-else :src="form.lecture_image" alt="">
                                        <span class="close_icon" @click="removeTempLectureImage"></span>
                                    </div>
                                </div>
                            </div>
                          <div class="col_2">
                            <div :class="['form-group', {'has_error': errorFor('order')}]">
                              <label>{{ $t('common.order') }}</label>
                              <input type="text" class="form_global" v-model="form.order">
                              <v-errors :errors="errorFor('order')" />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                            <div class="col_12">
                                <div :class="['form-group', {'has_error': errorFor('lecture_information')}]">
                                    <label>{{ $t('sidebar.lectureCommon.lecture_information') }}</label>
                                    <text-editor-component 
                                        :id="'lecture_information'" 
                                        :existingData="form.lecture_information ? form.lecture_information : ''" 
                                        @change="changeEditorValue"
                                    />
                                    <v-errors :errors="errorFor('lecture_information')" />
                                </div>
                            </div>
                        </div>

                        <!-- <div class="row">
                            <div class="col_12">
                                <div class="custom_heading2 mt_20">
                                    <h2>2.  학습 내용</h2>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="explanation_preview_videos.length">
                            <div class="col_12">
                                <div class="video_list">
                                    <div class="inner" v-for="(preview_video, index) in explanation_preview_videos" :key="index">
                                        <div class="inner_wrap">
                                            <img :src="preview_video.thumbs" alt="" v-if="preview_video.convert_status == 'Completed'">
                                            <img :src="baseUrl + 'assets/images/no_image.jpg'" alt="" v-else>
                                            <div class="icons">
                                                <span v-if="preview_video.smil" @click.prevent="showExplanationVideo(preview_video.smil)"><i class="lni lni-eye"></i></span>
                                                <span><i class="lni lni-trash" @click.prevent="removeExplanationVideo(preview_video)"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col_12">
                                <div class="form-group">
                                    <label>
                                        <h4>{{ $t('sidebar.lectureCommon.explanation_video') }}</h4>
                                    </label>

                                    <vue-dropzone ref="upload_explanation_dropzone" id="upload_explanation_dropzone"
                                        :class="{'dropzone_disable' : explanationDropzoneDisable}"
                                        @vdropzone-removed-file="vremovedExplanation"
                                        @vdropzone-success-multiple="vsuccessExplanationMuliple"
                                        :options="explanationDropzoneOptions"
                                        :duplicateCheck="true">
                                    </vue-dropzone>

                                    <v-errors :errors="errorFor('explanation_videos')" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col_12">
                                <div :class="['form-group', {'has_error': errorFor('explanation_video_url')}]">
                                    <label>해설 비디오 URL</label>
                                    <input type="text" class="form_global" v-model="form.explanation_video_url">
                                    <v-errors :errors="errorFor('explanation_video_url')"></v-errors>
                                </div>
                            </div>
                        </div> -->

                        <div class="row">
                            <div class="col_12">
                                <div class="custom_tabs">
                                    <nav class="tabs">
                                        <ul class="">
                                            <li href="#exams" class="active"> {{ $t('sidebar.exams.exams') }} </li>
                                        </ul>
                                    </nav>
                                    <div class="tab_content_wrapper">
                                        <div id="exams" class="tab_content show">
                                            <div class="fadein">
                                                <div class="custom_tab_content_inner">
                                                    <div class="add_new d_flex_end">
                                                        <button class="btn btn_blue ml_20 width_150p" @click="openModalWithType('examination')"><i class="lni lni-plus"></i>{{ $t('sidebar.exams.add_exam') }}</button>
                                                    </div>
                                                    <div class="custom_tab_table">
                                                        <table class="table">
                                                            <tr>
                                                                <!-- <th>{{ $t('sidebar.exam_type.exam_type') }}</th> -->
                                                                <th>{{ $t('common.title') }}</th>
                                                                <th>{{ $t('sidebar.exams.exam_time') }}</th>
                                                                <th>
                                                                    <div class="d_flex_end">{{ $t('common.action') }}</div>
                                                                </th>
                                                            </tr>
                                                            <tr v-for="(exam, index) in selectedExaminationExams" :key="index">
                                                                <!-- <td>{{ exam.examType ? exam.examType.name : '' }}</td> -->
                                                                <td>{{ exam.title }}</td>
                                                                <td>{{ exam.exam_time }} {{ $t('sidebar.lectureCommon.minute') }}</td>
                                                                <td>
                                                                    <div class="d_flex_end">
                                                                        <button class="btn btn_blue ml_10" @click="removeExam(exam.id)">
                                                                            <img :src="`${baseUrl}assets/media/images/icon/9.png`" alt="">
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <v-errors :errors="errorFor('exam_id')" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d_flex_end form_action_btn">
                            <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
                            <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <exam-modal v-if="openModal"
            :openModal="openModal" 
            :unit_id="form.unit_id"
            :subject_id="form.subject_id"
            :grade_id="form.grade_id"
            :semester_id="form.semester_id"
            :type="type"
            @examinationData="examinationData"
            @closeModal="closeModal">
        </exam-modal>

        <video-modal v-if="explanationVideoModalShow" :showVideoModal="explanationVideoModalShow" :video="explanationVideoSmilFile" @closeModal="closeModal()"></video-modal>
    </div>
</template>

<script>
import TextEditorComponent from "@/components/TextEditorComponent";
import Multiselect from '@vueform/multiselect'
import ExamModal from "../components/ExamModal";
import VideoModal from "../components/VideoModal";
// import vueDropzone from '../components/dropzone';
export default {
  components: { Multiselect, TextEditorComponent, ExamModal, VideoModal},
  data() {
    return {
        baseUrl: process.env.VUE_APP_BASE,
        title: this.$t('sidebar.thinkingSkill.addExamination'),
        cancelRouteName: 'thinking_skill_list',
        subjects: [],
        grades: [],
        semesters: [],
        parkings: [],
        chapters: [],
        units: [],
        areaList: [],
        form: {
            subject_id: '',
            grade_id: '',
            semester_id: '',
            parking_id: '',
            unit_id: '',
            chapter_id: '',
            page_number: '',
            status: 1,
            video_name: '',
            lecture_image: '',
            learning_goal: '',
            lecture_information: '',
            exam_id: [],
            explanation_video_url: '',
            order: '',
        },
        areas: [],
        explanation_videos : [],
        explanation_preview_videos : [],
        tempLectureImage : '',
        selectedExaminationExams: [],
        selectedExams: [],
        examinationRemoveableIds: [],
        openModal: false,
        type: '',
        examinationCheckEdAllStatus: false,
        explanationVideoModalShow: false,
        explanationVideoSmilFile: null,
        explanationVideoConvertStatus: 'pending',
        isUpload: false,
        explanationDropzoneOptions: {
            url: `${process.env.VUE_APP_API_BASE_URL}/upload/video`,
            thumbnailWidth: 150,
            maxFiles: 3,
            maxFilesize: 5368709120,
            uploadMultiple: true,
            allowMultiple: true,
            addRemoveLinks: true,
            acceptedFiles: "video/*",
            headers: {
                "Authorization": `Bearer `+ JSON.parse(localStorage.getItem('admin')).token
            }
        },
        explanationDropzoneDisable: false,
    }
  },
  created() {
    this.axios.get('/subjects').then((response) => this.subjects = response.data.data);
    this.axios.get('/grades').then((response) => this.grades = response.data.data);
    this.axios.get('/semesters').then((response) => this.semesters = response.data.data);
    this.axios.get('/parkings').then((response) => this.parkings = response.data.data);
    // this.axios.get('/chapters').then((response) => this.chapters = response.data.data);
    // this.axios.get('/units').then((response) => this.units = response.data.data);

    this.axios.get('/areas')
        .then((response) => {
            let lectureArea  = response.data.data
            
            if(lectureArea){
                lectureArea.forEach((element) => {
                    let lectureAreaList = {
                        value: element.id,
                        label: element.name
                    }
                    this.areaList.push(lectureAreaList)
                });
            }
        })

    if (this.$route.name === 'thinking_skill_examination_edit') {
      this.axios.get('/examinations/'+this.$route.params.id)
        .then((response) => {
            let videoData = response.data.data;
            this.form.subject_id = videoData.subject ? videoData.subject.id : ''
            this.form.grade_id = videoData.grade ? videoData.grade.id : ''
            this.form.semester_id = videoData.semester ? videoData.semester.id : ''
            this.form.parking_id = videoData.parking ? videoData.parking.id : ''
            this.form.unit_id = videoData.unit ? videoData.unit.id : ''
            this.form.chapter_id = videoData.chapter ? videoData.chapter.id : ''
            this.form.page_number = videoData.page_number
            this.form.status = videoData.status
            this.form.video_name = videoData.video_name
            this.form.lecture_image = videoData.lecture_image
            this.form.learning_goal = videoData.learning_goal
            this.form.lecture_information = videoData.lecture_information
            this.form.order = videoData.order

            this.editChangeData();

            if(videoData.areas){
                let areaData = [];
                videoData.areas.forEach(element => {
                    areaData.push(element.area_id)
                });

                this.areas = areaData
            }

            if(videoData.examinations){
                let examinationExamData = [];
                videoData.examinations.forEach(element => {
                    if(element.exam){
                        examinationExamData.push(element.exam)
                    }
                });

                this.selectedExaminationExams = examinationExamData
            }

            let explanationVideoList  = videoData.explanationVideos

            this.explanation_preview_videos = explanationVideoList

            if(this.explanation_preview_videos.length >= 3){
                this.explanationDropzoneDisable = true
            }

            let explanation_video_url = '';

            explanationVideoList.forEach((element) => {
                if(element.explanation_video_url){
                    explanation_video_url += element.explanation_video_url + ",";
                }

                if(element.explanation_video_url == null){
                    let explanationOriginalFile = {
                        original_file: element.original_filename,
                        file: ''
                    }
                    this.explanation_videos.push(explanationOriginalFile)
                }
            });

            if(explanation_video_url){
                this.form.explanation_video_url = explanation_video_url
            }
        })
      this.title = this.$t('sidebar.thinkingSkill.editExamination');
    }
  },
  watch:{
    examinationCheckEdAllStatus:function(){
        if(this.examinationCheckEdAllStatus){
            this.examinationRemoveableIds = this.selectedExaminationExams.map((i)=>i.id)
        }else{
            this.examinationRemoveableIds = []
        }
    }
  },
  methods: {
    changeEditorValue(editorId, data){
      this.form[editorId] = data
    },
    onFileChange(e){
      this.form.lecture_image = e.target.files[0]
      this.tempLectureImage = URL.createObjectURL(e.target.files[0]);
    },
    removeTempLectureImage(){
      this.tempLectureImage = ''
      this.form.lecture_image = ''
      this.$refs.lecture_image.value = null;
    },
    vremovedExplanation(file) {
        let filename = this.explanation_videos.find(object => { return object.original_file === file.name; });
        this.axios.post('/delete-lecture-local-video', { 'name' : filename.file})
          .then(() => {
            this.showSuccessMsg('Video Removed Successfully!')
            let index = this.explanation_videos.findIndex(object => { return object.original_file === file.name; });
            if (index !== -1){
                this.explanation_videos.splice(index, 1);
            }

            if (this.explanation_videos.length >= 3){
                this.explanationDropzoneDisable = true
            }else{
                this.explanationDropzoneDisable = false
            }
        });
    },
    vsuccessExplanationMuliple(file, response) {
        response.forEach((element,index) => {
            let lectureOriginalFile = {
                original_file: file[index].name,
                file: element.original_filename
            }
            this.explanation_videos.push(lectureOriginalFile)
        });

        if (this.explanation_videos.length >= 3){
            this.explanationDropzoneDisable = true
        }else{
            this.explanationDropzoneDisable = false
        }
    },
    removeExam(id){
        this.selectedExams = [];

        this.selectedExams = this.selectedExaminationExams

        var index = this.selectedExams.findIndex(object => { return object.id === id; });
        if (index !== -1)
            this.selectedExams.splice(index, 1);

        if(!this.selectedExams.length){
            this.examinationCheckEdAllStatus = false
        }
    },
    openModalWithType(type){
        this.type = type
        this.openModal = true
    },
    examinationData(data){
        if(data.length){
            this.selectedExaminationExams = data
        }
    },
    showExplanationVideo(smil){
        this.explanationVideoSmilFile = smil
        this.explanationVideoModalShow = true
    },
    removeExplanationVideo(video){
        let videoId = video.id
        this.axios.post('/delete-lecture-video', { 'id' : videoId})
        .then(() => {
            this.showSuccessMsg('Video Removed Successfully!')
            var lectureIndex = this.explanation_videos.find(object => { return object.original_file === video.original_file; });
            if (lectureIndex !== -1){
                this.explanation_videos.splice(lectureIndex, 1);
            }
            var lecturePreviewIndex = this.explanation_preview_videos.findIndex(object => { return object.id === video.id; });
            if (lecturePreviewIndex !== -1){
                this.explanation_preview_videos.splice(lecturePreviewIndex, 1);
            }

            if (this.explanation_preview_videos.length >= 3){
                this.explanationDropzoneDisable = true
            }else{
                this.explanationDropzoneDisable = false
            }
        });
    },
    closeModal(){
      this.openModal = false
      this.explanationVideoModalShow = false
    },
    submit() {
        if(this.isUpload){
            this.showFailMsg('비디오 업로드가 아직 완료되지 않았습니다.')
            return;
        }
        this.allErrors = null;
        this.loading = true;
            
        if(this.selectedExaminationExams){
            this.form.exam_id = this.selectedExaminationExams.map(exam => exam.id)
        }

        if (this.$route.name === 'thinking_skill_examination_edit') {
            this.loading = true;
            this.errors = null;

            let formData = new FormData();

            Object.keys(this.form).forEach(key => {
                formData.append(key, this.form[key] ? this.form[key] : '');
            })

            formData.append('lecture_areas', JSON.stringify(this.areas))
            formData.append('explanation_videos', JSON.stringify(this.explanation_videos))
            formData.append('lecture_status', JSON.stringify(this.form.status))

            formData.append('_method','PATCH')

            this.axios.post('/examinations/'+this.$route.params.id, formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            })
            .then(() => {
                this.$router.push({name: 'thinking_skill_list'});
                this.showSuccessMsg(this.$t('common.updateSuccess'))
            })
            .catch((err) => {
                this.allErrors = err.response.data.errors;
            })
            .finally(() => {
                this.loading = false;
            });
        } else {
            let formData = new FormData()

            Object.keys(this.form).forEach(key => {
                formData.append(key, this.form[key] ? this.form[key] : '');
            })

            formData.append('lecture_areas', JSON.stringify(this.areas))
            formData.append('explanation_videos', JSON.stringify(this.explanation_videos))
            formData.append('lecture_status', JSON.stringify(this.form.status))
            
            this.axios.post('/examinations/', formData,{
                headers: {
                'Content-Type': 'multipart/form-data'
                },
            })
            .then(() => {
                this.$router.push({name: 'thinking_skill_list'});
                this.showSuccessMsg(this.$t('common.addSuccess'))
            })
            .catch((err) => {
                this.allErrors = err.response.data.errors;
            })
            .finally(() => {
                this.loading = false;
            });
        }
    },
    changeData(){
      let grade_id = this.form.grade_id

      if(grade_id == ''){
        this.units = []
        this.form.unit_id = ''
        this.chapters = []
        this.form.chapter_id = ''
      }

      let semester_id = this.form.semester_id

      if(semester_id == ''){
        this.form.unit_id = ''
        this.units = []
        this.chapters = []
        this.form.chapter_id = ''
      }

      if(grade_id && semester_id){
          this.units = []
          this.form.unit_id = ''
          this.chapters = []
          this.form.chapter_id = ''
          this.axios.post('/load-unit-data/', {'grade_id': grade_id, 'semester_id': semester_id})
              .then((response) => {
                  let unitData = response.data.data
                  this.units = unitData
                  if(unitData && unitData.length < 1){
                      this.form.unit_id = ''
                      this.units = []
                  }
              })

          this.axios.post('/load-chapter-data/', {'grade_id': grade_id, 'semester_id': semester_id})
              .then((response) => {
                  let chapterData = response.data.data
                  this.chapters = chapterData
                  if(chapterData && chapterData.length < 1){
                      this.form.chapter_id = ''
                      this.chapters = []
                  }
              })
      }
    },
    editChangeData(){
      let grade_id = this.form.grade_id

      if(grade_id == ''){
        this.units = []
        this.form.unit_id = ''
        this.chapters = []
        this.form.chapter_id = ''
      }

      let semester_id = this.form.semester_id

      if(semester_id == ''){
        this.units = []
        this.form.unit_id = ''
        this.chapters = []
        this.form.chapter_id = ''
      }

      if(grade_id && semester_id){
          this.axios.post('/load-unit-data/', {'grade_id': grade_id, 'semester_id': semester_id})
            .then((response) => {
                let unitData = response.data.data
                this.units = unitData
                if(unitData && unitData.length < 1){
                    this.form.unit_id = ''
                    this.units = ''
                }
            })

          this.axios.post('/load-chapter-data/', {'grade_id': grade_id, 'semester_id': semester_id})
            .then((response) => {
                let chapterData = response.data.data
                this.chapters = chapterData
                if(chapterData && chapterData.length < 1){
                    this.form.chapter_id = ''
                    this.chapters = ''
                }
            })
      }
    },
  }
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
    .dropzone_disable {
        pointer-events: none;
        cursor: default;
    }
    .dropzone_disable .dropzone .dz-message{
        display: none !important;
    }
</style>
